import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, ElementRef, Injector, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DateFormatPipe, EddyAutoComplete, FuncaoService, GlobalService, Indicador, Login, RplItem, Unidade, UnidadeRecurso, UnidadeRecursoSubstituto, Usuario, UsuarioService } from 'eddydata-lib';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AutoComplete } from 'primeng/autocomplete';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';
import { AcaoGovernoAdicionalService } from 'projects/administrativo-lib/src/lib/planejamento/meta-governo/service/acao-governo-adicional.service';
import { AcaoGovernoAdicional } from 'projects/eddydata-lib/src/lib/entidade/planejamento/acao-governo-adicional.model';
import { AcaoGovernoService } from 'administrativo-lib';

declare var $: any;

@Component({
  selector: 'app-acao-governo-adicional-dlg',
  templateUrl: './acao-governo-adicional-dlg.component.html'
})
export class AcaoGovernoAdicionalDlgComponent implements OnInit, OnChanges {

  @Input() entity: Indicador;
  @Input() login: Login = new Login();

  public listaAcaoGovernoAdicional: Array<AcaoGovernoAdicional> = new Array<AcaoGovernoAdicional>();
  public listaAcoes: Array<any>;
  protected unsubscribe: Subject<void> = new Subject();
  public metaAutoComplete: EddyAutoComplete<Usuario>;
  public edicao: boolean = false;
  public itemAnterior: AcaoGovernoAdicional;
  public itemAtual: AcaoGovernoAdicional;
  public ptBR: any;

  public imaskQtd = {
    mask: Number,
    scale: 8,
    signed: false
  };

  constructor(
    protected injector: Injector,
    protected acaoGovernoAdicionalService: AcaoGovernoAdicionalService,
    protected acaoGovernoService: AcaoGovernoService,
    protected confirmationService: ConfirmationService,
    public globalService: GlobalService,
    public funcaoService: FuncaoService,
    private messageService: MessageService,
  ) {
    this.ptBR = new GlobalService().obterDataBR();
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.entity?.id) {
      this.acaoGovernoAdicionalService.filtrar(1, -1, { 'indicador.id': this.entity?.id, relations: 'indicador,acao_governo.acao' }).pipe(takeUntil(this.unsubscribe)).subscribe(a => {
        this.listaAcaoGovernoAdicional = a ? a.content : []
      });

      this.acaoGovernoService
        .filtrar(1, -1, { 'meta.id': this.entity.meta.id, 'ppa.id': this.login['ppa']?.id, relations: 'acao,meta' })
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          this.listaAcoes = res.content;
        }, error => {
          this.messageService.add({ severity: 'error', summary: 'Filtro', detail: error.error.payload });
          throw error;
        });
    }
  }

  public async adicionarItem() {
    if (this.edicao) return;
    await this.preencherListaAcoes();
    this.adicionar();
  }

  private adicionar() {
    if (this.edicao) return;
    if (this.listaAcaoGovernoAdicional && this.listaAcaoGovernoAdicional.find((itm) => { return itm['editavel'] === true })) {
      toastr.info('Finalize a edição atual antes de incluir outro item');
      return;
    }

    this.itemAnterior = undefined;
    this.itemAtual = new AcaoGovernoAdicional();
    this.itemAtual['editavel'] = true;
    this.edicao = true;

    this.listaAcaoGovernoAdicional.unshift(this.itemAtual);
  }

  public async salvar(item: AcaoGovernoAdicional = new AcaoGovernoAdicional()) {
    if (!this.edicao) return;
    try {
      this.itemAtual['editavel'] = false;
      this.itemAtual = undefined;
      this.itemAnterior = undefined;
      this.edicao = false;
      item.indicador = this.entity;

      this.acaoGovernoAdicionalService.inserir(item).pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          item = res;
          this.listaAcaoGovernoAdicional = this.listaAcaoGovernoAdicional.map(it => {
            if (it.acao_governo?.id === item.acao_governo?.id) {
              return {
                ...it,
                id: item.id
              };
            }
            return it;
          });

          toastr.success('Indicador adicional incluído com sucesso!');
        }, (e) => {
          toastr.error('Falha ao incluir indicador adicional, ' + (e.error?.erro ? e.error.erro : e.error?.payload ? e.error.payload : JSON.stringify(e)));
        });
    } catch (e) {
      this.funcaoService.acaoErro(e)
      throw e;
    }
  }

  public fechar() {
    if (this.edicao) return;
    $(`#acaoGovernoAdicional`).modal('hide');
  }

  public remover(item: AcaoGovernoAdicional, index: number) {
    if (this.edicao) return;
    if (item.id) {
      this.confirmationService.confirm({
        message: `Tem certeza que deseja desvincular o item?`,
        key: 'rifd',
        header: 'Exclusão',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Confirmar',
        rejectLabel: 'Cancelar',
        accept: () => {
          this.acaoGovernoAdicionalService.remover(item.id).pipe(takeUntil(this.unsubscribe))
            .subscribe((res) => {
              toastr.info('Registro removido com sucesso!', 'Exclusão');
              this.listaAcaoGovernoAdicional.splice(index, 1);
            }, (err) => toastr.error(err.error.payload));
        }
      });

    }
  }

  public editar(item: AcaoGovernoAdicional = new AcaoGovernoAdicional()) {
    if (this.edicao) return;
    if (this.listaAcaoGovernoAdicional && this.listaAcaoGovernoAdicional.find((itm) => { return itm['editavel'] === true })) {
      toastr.info('Finalize a edição atual antes de editar outro item');
      return;
    }
    this.itemAnterior = Object.assign({}, item);
    this.itemAtual = item;
    this.itemAtual['editavel'] = true;
    this.edicao = true;
  }

  public cancelar(item: RplItem, index: number) {
    if (!this.edicao) return;
    this.itemAtual = Object.assign({}, this.itemAnterior);

    if (!this.itemAtual) {
      this.listaAcaoGovernoAdicional.splice(index, 1);
    } else if (!item.id) {
      this.listaAcaoGovernoAdicional.splice(index, 1);
    } else {
      item['editavel'] = false;
    }
    this.itemAtual = undefined;
    this.itemAnterior = undefined;
    this.edicao = false;
  }

  public async confirmar() {
    if (this.edicao) return;
    if (this.listaAcaoGovernoAdicional.length <= 0 && this.entity.id) {
      toastr.info('Informe o responsável substituto!');
      return;
    }

    $('#acaoGovernoAdicional').modal('hide');
  }

  compareFn(c1: any, c2: any): boolean {
    if (c1 && c2) {
      if (c1.id && c2.id) {
        return c1.id === c2.id;
      } else if (c1.chave && c2.chave) {
        return c1.chave == c2.chave;
      } else {
        return c1 === c2;
      }
    } else {
      return false;
    }
  }

  public async preencherListaAcoes() {
    this.listaAcaoGovernoAdicional = (await this.acaoGovernoAdicionalService.filtrar(1, -1, { 'indicador.id': this.entity?.id, relations: 'indicador,acao_governo.acao' }).toPromise()).content;

    const idsAdicionais = new Set(
      this.listaAcaoGovernoAdicional?.map(i => i.acao_governo?.id)
    );

    this.listaAcoes = this.listaAcoes.filter(i =>
      i.id !== this.entity?.acao_governo?.id &&
      !idsAdicionais.has(i.id)
    );
  }
}
